export enum AccountType {
    Savings = 1,
  Current = 2,
  Transmission = 3,
}

export enum BulkMessageNotificationType {
    Sms = 1,
    Email = 2
  }
  
  export enum MessageType {
    Single = 1,
    Bulk = 2
  }
